const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Choisissez le bon plan grâce à une tarification simple et transparente",
  monthlyUppercase: "MENSUEL",
  montly: "Mensuel",
  free: "GRATUIT",
  yearlyUppercase: "ANNUELLEMENT",
  yearly: "Chaque année",
  inService: "En Service",
  buyBtn: "Acheter Maintenant",
  freeTips1: "Supporte une taille de fichier maximale de 20MB",
  freeTips2: "6 chances de traiter des dossiers par jour",
  freeTips3: "Vitesse de traitement normale",
  freeTips4: "Vitesse de téléchargement normale",
  freeTips5: "Une possibilité d'élimination du fond par jour",
  freeTips6: "Tous les outils gratuits sont autorisés",
  vipTips1: "Taille de fichier illimitée",
  vipTips2: "Aucune limite sur le nombre de fichiers traités",
  vipTips3: "Vitesse de téléchargement 10 fois plus rapide",
  vipTips4: "Vitesse de traitement 10 fois plus rapide",
  vipTips5: "Illimité",
  vipTips6: "Suppression illimitée d'images d'arrière-plan par jour",
  vipTips7: "Permet d'accéder à tous les outils et aux fonctions avancées",
  vipTips8: "Renouvellement automatique et annulation à tout moment",
  vipTips9: "Aucune limite de taille et de quantité de vidéos",
  vipTips10: "Suppression des arrière-plans d'image sans limite",
  vipTips11: "Vitesse de traitement et de téléchargement des vidéos 10 fois plus rapide",
  vipTips12: "Accès à tous les outils gratuits et aux fonctions premium",
  acceptTitle: "Nous Acceptons",
  modalTitle: "Passez à la version Pro pour accéder à toutes les fonctionnalités premium",
  total: "Tous",
  enterCode: "Entrez le code",
  SignUpToPurchaseBtn: "Inscrivez-vous et acheter",
  purchaseBtn: "Aller à l'achat",
  saveTips: "Économisez jusqu'à {{num}} %.",
  discount: "Remises",
  purchaseTips: "Renouvellement automatique et annulation à tout moment",
  tips: "Note:",
  promoCodeInvalidTips: "Votre code promo n'est pas valide",
};

export default purchase;
